import { COMPONENT_TYPES } from '../../../constants';
import ProductDetailComponent from './ProductDetail.component';
import ProductDetailEditor from './ProductDetail.editor';
import ProductDetailProperties from './ProductDetail.properties';
import { registerComponent } from '../registry';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.PRODUCT_DETAIL, // constants.js에 정의된 타입 상수 사용
  component: ProductDetailComponent,
  editorComponent: ProductDetailEditor,
  properties: ProductDetailProperties, // 직접 변수 참조
  defaultProps: {
    // 기본 속성 정의
    style: {
      backgroundColor: '#fff',
      width: '100%',
      maxWidth: '100%',
      padding: '40px 0',
    },
    componentProps: {
      productId: 0,
      order: '',
      none: 'none',
      lg: 9,
      showDescriptionTab: true,
      showReviewsTab: true,
      showSpecificationTab: true,
      showStock: false
    }
  },
  category: 'shop', // 컴포넌트 카테고리
  icon: '🛒', // 대표 아이콘
  name: '상품 상세', // 표시할 이름
  description: '상품 상세 정보를 표시하는 컴포넌트입니다.'
});

// 컴포넌트 및 타입 내보내기
export { default as ProductDetailComponent } from './ProductDetail.component';
export { default as ProductDetailEditor } from './ProductDetail.editor';
export { default as ProductDetailProperties } from './ProductDetail.properties';
export * from './ProductDetail.types'; 